import { useState } from "react";
import { Download, FileText, Loader2, QrCode } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { BASE } from "@/lib/api";

export const PosterButton = ({ committee }) => {
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const base = `${BASE}/api/admin/committees/${committee.id}/poster`;
  const site = (BASE || window.location.origin).replace(/^https?:\/\//, "");

  return (
    <>
      <button type="button" onClick={() => { setLoaded(false); setOpen(true); }} data-testid={`admin-committee-poster-${committee.id}`} className="rounded-lg p-2 text-maroon hover:bg-gold/20" aria-label="QR poster">
        <QrCode className="h-4 w-4" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="poster-dialog" className="max-h-[92vh] w-[calc(100%-2rem)] max-w-md overflow-y-auto rounded-2xl bg-ivory">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl text-maroon">Venue QR poster</DialogTitle>
            <DialogDescription>A4 printable poster for {committee.name}. The QR opens {site}.</DialogDescription>
          </DialogHeader>
          <div className="relative grid min-h-[300px] place-items-center overflow-hidden rounded-xl border border-gold/40 bg-white">
            {open && <img src={`${base}.png?preview=true&t=${Date.now() >> 16}`} alt={`QR poster for ${committee.name}`} onLoad={() => setLoaded(true)} data-testid="poster-preview-img" className={`w-full ${loaded ? "" : "opacity-0"}`} />}
            {!loaded && <Loader2 className="absolute h-6 w-6 animate-spin text-maroon" />}
          </div>
          <div className="grid grid-cols-2 gap-2">
            <a href={`${base}.pdf`} data-testid="poster-download-pdf" className="flex h-11 items-center justify-center gap-2 rounded-full bg-maroon text-sm font-semibold text-ivory">
              <FileText className="h-4 w-4" /> Download PDF
            </a>
            <a href={`${base}.png`} data-testid="poster-download-png" className="flex h-11 items-center justify-center gap-2 rounded-full border border-maroon text-sm font-semibold text-maroon">
              <Download className="h-4 w-4" /> Download PNG
            </a>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
